import type { IconNode } from '../types';

/**
 * @name arrows-up-down-square
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtNiA5IDMtMyAzIDMiIC8+CiAgPHBhdGggZD0iTTkgNnY2IiAvPgogIDxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgeD0iMiIgeT0iMiIgcng9IjIiIC8+CiAgPHBhdGggZD0iTTE1IDE4di02IiAvPgogIDxwYXRoIGQ9Im0xOCAxNS0zIDMtMy0zIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/arrows-up-down-square
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const arrowsUpDownSquare: IconNode = [
  ['path', { d: 'm6 9 3-3 3 3', key: '1cy1gs' }],
  ['path', { d: 'M9 6v6', key: 'exg0pk' }],
  ['rect', { width: '20', height: '20', x: '2', y: '2', rx: '2', key: '1btzen' }],
  ['path', { d: 'M15 18v-6', key: 'jbu0s7' }],
  ['path', { d: 'm18 15-3 3-3-3', key: 'h7onfb' }],
];

export default arrowsUpDownSquare;
